import PortalService from '@/services/portal.service';

export const edit = {
  namespaced: true,

  state: {
    users: [],

    user: null,
    userCompanyTypes: [],
    userRoles: [],
    groupCompanySelected: null,
  },

  actions: {
    async loadUsers({ commit }) {
      await PortalService.getUsers().then(response => {
        commit('updateUsers', response.data);
      });
    },

    cleanEdit({ commit }) {
      // clear form
      commit('cleanEdit');
    },

    selectGroupCompanySelected({ commit }, company) {
      // clear form
      commit('selectGroupCompanySelected', company);
    },

    async toEdit({ commit, dispatch, rootState }, user) {
      // show overlay
      dispatch('common/showOverlay', null, { root: true });

      // clear form
      await commit('cleanEdit');

      // load user data
      const userData = await PortalService.getUser(user.idUser).catch((error) => Promise.reject(error));

      // update user data, user company types and roles
      commit('updateUserData', userData);
      commit('updateUserCompanyTypes', { rootState, userCompanyTypes: userData.userCompany });
      commit('updateUserRoles', { rootState, groupIds: userData.groupIds });

      // hide overlay
      dispatch('common/hideOverlay', null, { root: true });
      return Promise.resolve(userData);
    },

    async newUser({ commit, dispatch, rootState }) {
      // show overlay
      dispatch('common/showOverlay', null, { root: true });

      // clear form
      await commit('cleanEdit');

      // reset user data, user company types and roles
      commit('updateUserData', {
        username: null,
        email: null,
        membershipCompany: null,
        firstName: null,
        lastName: null,
        fullName: null,
        enablePws: 0,
        notificationLoginMail: 0,
        notificationLoginLog: 0
      });
      commit('updateUserCompanyTypes', { rootState, userCompanyTypes: [] });
      commit('updateUserRoles', { rootState, groupIds: [] });

      // hide overlay
      dispatch('common/hideOverlay', null, { root: true });
    }
  },

  mutations: {
    updateUsers(state, users) {
      state.users = users;
    },

    selectGroupCompanySelected(state, company) {
      console.log(company)
      state.groupCompanySelected = company;
    },

    cleanEdit(state) {
      state.user = null;
      state.userCompanyTypes = [];
      state.userRoles = [];
      state.groupCompanySelected = null;
    },

    updateUserData(state, user) {
      state.user = user;
    },

    updateUserCompanyTypes(state, { rootState, userCompanyTypes }) {
      const userCompanyTypesWrapper = [];
      rootState.company.companiesAvailable.forEach(company => {
        const itemFound = userCompanyTypes.find(uct => uct.idCompany === company.idCompany);
        if (itemFound) {
          userCompanyTypesWrapper.push({ selected: 1, company: company, ...itemFound });
        } else {
          userCompanyTypesWrapper.push({ selected: 0, company: company });
        }
      });
      state.userCompanyTypes = userCompanyTypesWrapper;
    },

    updateUserRoles(state, { rootState, groupIds }) {
      console.debug('updateUserRoles groupIds', groupIds);
      let userCompanyRole = {};
      state.userCompanyTypes.forEach(company => {
        console.debug('updateUserRoles for company', company);
        userCompanyRole[company.company.idCompany] = {
            selected: false,
            application: []
        };
        rootState.role.rolesAvailable.forEach(application => {
            let appCopy = JSON.parse(JSON.stringify(application));
          appCopy.selected = false;
          appCopy.groups.forEach(group => {
            group.selected = groupIds[company.company.idCompany]?.includes(group.idGroup);
            if (group.selected) {
              appCopy.selected = true;
            }
          });
          userCompanyRole[company.company.idCompany].application.push(appCopy);
        });
      })

      userCompanyRole[state.userCompanyTypes[0].company.idCompany].selected = true;

      state.userRoles = userCompanyRole;
    }
  },

  getters: {
    users(state) {
      return state.users;
    },

    user(state) {
      return state.user;
    },

    userCompanyTypes(state) {
      return state.userCompanyTypes;
    },

    userRoles(state) {
      return state.userRoles;
    },

    groupCompanySelected(state) {
      return state.groupCompanySelected;
    }
  }
};
